import { PropsWithChildren } from "react";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";

const LoggedOutRoute = ({ children }: PropsWithChildren<Record<string, unknown>>): JSX.Element => {
    const isLoggedIn = useIsLoggedIn();

    return (
        <ProtectedRoute isAllowed={!isLoggedIn} redirectPath={MainRoutes.MAIN}>
            {children}
        </ProtectedRoute>
    );
};

export default LoggedOutRoute;
